import axios from 'axios';
import { useQuery, useMutation, useQueryClient } from 'react-query';

const API_BASE_URL = '/api';

export const useUserSettings = (userId, token) => {
    return useQuery(['userSettings', userId], async () => {
        const response = await axios.get(`${API_BASE_URL}/get/user-settings/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    });
};